export default __webpack_public_path__ + "static/media/phylactere_pas_toute_seule_NL.4d8e27db.png";